import { render, staticRenderFns } from "./InputChat.vue?vue&type=template&id=90f9fff4&scoped=true"
import script from "./InputChat.vue?vue&type=script&lang=js"
export * from "./InputChat.vue?vue&type=script&lang=js"
import style0 from "./InputChat.vue?vue&type=style&index=0&id=90f9fff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f9fff4",
  null
  
)

export default component.exports